
import { SEO } from '../../utils/seo';
import HeroSection from './components/HeroSection';
import CompanyStorySection from './components/CompanyStorySection';
import MissionSection from './components/MissionSection';
import WhyChooseUsSection from './components/WhyChooseUsSection';
import RentalSection from './components/RentalSection';
import TeamSection from './components/TeamSection';
import CTASection from './components/CTASection';
import Footer from '../../components/feature/Footer';
import GlobalNavbar from '../../components/feature/GlobalNavbar';

export default function AboutPage() {
  return (
    <div className="min-h-screen bg-white">
      <SEO
        title="About TREX RE LLC | El Paso Cash Home Buyers Since 2016"
        description="Learn about TREX RE LLC, El Paso's trusted cash home buyers since 2016. We buy houses, land, and distressed properties with integrity and fair offers. Meet our team."
        keywords="about TREX RE LLC, El Paso real estate investors, cash home buyers El Paso, local property buyers, sell house fast El Paso"
        canonical="/about"
        schema={{
          "@context": "https://schema.org",
          "@type": "AboutPage",
          "mainEntity": {
            "@type": "RealEstateAgent",
            "name": "TREX RE LLC",
            "foundingDate": "2016",
            "areaServed": "El Paso, TX"
          }
        }}
      />
      <GlobalNavbar />
      <HeroSection />
      <CompanyStorySection />
      <MissionSection />
      <WhyChooseUsSection />
      <RentalSection />
      <TeamSection />
      <CTASection />
      <Footer />
    </div>
  );
}
